import { render, staticRenderFns } from "./ContactInfoMaintenance.vue?vue&type=template&id=2344a546"
import script from "./ContactInfoMaintenance.vue?vue&type=script&lang=js"
export * from "./ContactInfoMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2344a546')) {
      api.createRecord('2344a546', component.options)
    } else {
      api.reload('2344a546', component.options)
    }
    module.hot.accept("./ContactInfoMaintenance.vue?vue&type=template&id=2344a546", function () {
      api.rerender('2344a546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/BaseDataManage/ContactInfoMaintenance.vue"
export default component.exports